module.exports = __webpack_public_path__ + "img/s24.fd555d9.png";